import React from 'react'

import type { RouteGuardProps } from '../routes.types'
import { PermissionErrorBoundary } from '../../features/authorization/components/PermissionErrorBoundary'

import { AuthGuard } from './AuthGuard'
import { OrganizationGuard } from './OrganizationGuard'
import { PermissionGuard } from './PermissionGuard'

export function ProtectedRoute({
    children,
    requireAuth = true,
    requireOrganization = false,
    requiredPermission,
}: RouteGuardProps) {
    return (
        <PermissionErrorBoundary>
            <AuthGuard requireAuth={requireAuth}>
                <OrganizationGuard requireOrganization={requireOrganization}>
                    {/* SECURITY: Pure CASL permission-based authorization only */}
                    <PermissionGuard requiredPermission={requiredPermission}>{children}</PermissionGuard>
                </OrganizationGuard>
            </AuthGuard>
        </PermissionErrorBoundary>
    )
}
